export const FORM_WITH_SEQ_LOGIC = {
  id: '67ea3a3ae3e47d18899cde24',
  title: 'Career Interests Survey',
  settings: {
    language: 'en',
    progress_bar: 'percentage',
    meta: {
      title: 'Bootcamp Application Form',
      description: '',
      allow_indexing: true,
      image: {
        link: 'https://buildform-file-uploads-v2.s3.ap-southeast-1.amazonaws.com/8392859fb193b51771d9e36cc9920c7d.jpeg'
      }
    },
    hide_navigation: false,
    is_public: true,
    is_trial: false,
    show_progress_bar: true,
    are_uploads_public: false,
    show_time_to_complete: false,
    show_number_of_submissions: true,
    show_cookie_consent: false,
    show_question_number: true,
    show_key_hint_on_choices: true,
    autosave_progress: true,
    free_form_navigation: false,
    accept_responses: true,
    analytics: null
  },
  thankyou_screens: [
    {
      id: 'd6765d1e-6e70-4d14-b81c-12fde62666af',
      title: 'Thank You!',
      type: 'thankyou_screen',
      properties: {
        description:
          "Thank you for participating in our Career Interests Survey. Your responses are valuable to us! If you're interested in creating a similar survey, check out BuildFormAI.",
        redirect_url: null,
        show_button: true,
        share_icons: true,
        button_mode: 'redirect',
        button_text: 'Continue',
        text_align: 'center'
      },
      attachment: null,
      layout: null
    }
  ],
  welcome_screens: [
    {
      id: 'd4a0123c-5a41-4347-91e6-f7e47ac1c032',
      title: 'Welcome to the Career Interests Survey!',
      type: 'welcome_screen',
      properties: {
        description: "We are excited to hear about your career aspirations. Your insights will help us understand the trends among university students. Let's get started!",
        redirect_url: 'https://www.google.com',
        show_button: true,
        share_icons: true,
        button_mode: 'redirect',
        button_text: 'Start Survey',
        text_align: 'center'
      },
      attachment: {
        _id: '',
        type: 'image',
        link: '',
        properties: {
          description: '',
          focal_point: {
            x: 0.0,
            y: 0.0
          }
        },
        placement: 'top'
      },
      layout: {
        type: 'float',
        attachment: {
          _id: '',
          type: 'image',
          link: 'https://buildform-file-uploads-v2.s3.amazonaws.com/214a9f8ea471e4c0e91964fd1eb4437603140b1d19d365440ca9d14a782f7d52.jpg',
          properties: {
            description: '',
            focal_point: {
              x: 0.5,
              y: 0.5
            }
          },
          placement: 'right'
        },
        placement: 'right',
        viewport_overrides: {
          large: {
            type: 'float',
            placement: 'top'
          }
        }
      }
    }
  ],
  fields: [
    {
      question_number: '9',
      id: 'ouvtv83kx9',
      title: 'Short options',
      subfield_key: null,
      validations: {
        required: false
      },
      type: 'multiple_choice',
      properties: {
        default_country_code: null,
        fields: null,
        description: '',
        randomize: null,
        choices: [
          {
            id: '7666049c-e481-4ee9-9a92-d6d8a3e20de7',
            label: 'WhatsApp is better?',
            value: null
          },
          {
            id: 'a6f626e0-047e-435a-84ea-c2566573f2f6',
            label: 'Email',
            value: null
          },
          {
            id: 'c1f21009-8783-4618-831c-e6365cace082',
            label: 'Phone',
            value: null
          }
        ],
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: false,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: {
        _id: null,
        type: 'image',
        link: '',
        properties: null,
        placement: 'right'
      },
      layout: null
    },
    {
      question_number: '1',
      id: 'vjfwk29ir4',
      title: 'This is a statement',
      subfield_key: null,
      validations: null,
      type: 'section',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Statement description goes here',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: null,
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '2',
      id: 'tyswjp876q',
      title: 'Your email?',
      subfield_key: null,
      validations: {
        required: false
      },
      type: 'email',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Description goes here',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '3',
      id: 'fj2h88d7zk',
      title: 'Legal',
      subfield_key: null,
      validations: null,
      type: 'legal',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Legal description',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '4',
      id: '7a6004bd-af12-434b-82a9-579ba672d197',
      title: 'What is your current major?',
      subfield_key: null,
      validations: {
        required: true
      },
      type: 'short_text',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Please enter your major or field of study.',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: null,
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '5',
      id: 'ydd5vdrzqd',
      title:
        'Greet the user {{field:tyswjp876q}} and then considering the {{field:fj2h88d7zk}} state and the entered {{field:7a6004bd-af12-434b-82a9-579ba672d197}} let them know any cool insights  ',
      subfield_key: null,
      validations: null,
      type: 'ai_statement',
      properties: {
        default_country_code: null,
        fields: null,
        description: '',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: {
        _id: null,
        type: 'image',
        link: 'https://buildform-file-uploads-v2.s3.amazonaws.com/1c02bc5c93741656786690622ee82182338dcf807555b7cd6b2a50d1c218a561.jpg',
        properties: null,
        placement: 'right'
      },
      layout: null
    },
    {
      question_number: '6',
      id: 'm99tsfx7',
      title: 'Another short text',
      subfield_key: null,
      validations: {
        required: false
      },
      type: 'short_text',
      properties: {
        default_country_code: null,
        fields: null,
        description: '',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: {
        _id: null,
        type: 'image',
        link: '',
        properties: null,
        placement: 'right'
      },
      layout: null
    },
    {
      question_number: '7',
      id: '505432ae-711e-4903-ba5d-9044fddb7a64',
      title: 'What career fields are you interested in?',
      subfield_key: null,
      validations: {
        required: true
      },
      type: 'multiple_choice',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Select the career fields you are most interested in.',
        randomize: null,
        choices: [
          {
            id: '2895d1ce-d6ac-4495-bce3-11ce6b972eaa',
            label: 'Business',
            value: 'Business'
          },
          {
            id: '4ae883bd-9f59-4a05-be89-2931adb387b4',
            label: 'Engineering',
            value: 'Engineering'
          },
          {
            id: 'fd345505-aed6-45cc-8911-6d0366a3aa40',
            label: 'Healthcare',
            value: 'Healthcare'
          },
          {
            id: '0b2476ee-110c-4b23-9bd5-c6436f85c2b0',
            label: 'Education',
            value: 'Education'
          },
          {
            id: 'fce1ef9f-b68b-4bdf-97f7-375ca19058a0',
            label: 'Arts',
            value: 'Arts'
          },
          {
            id: '14455803-9557-4400-84b8-823a5ab81a2b',
            label: 'Technology',
            value: 'Technology'
          },
          {
            id: '97c11c6a-f28a-43ec-ba73-9c1e89882646',
            label: 'Science',
            value: 'Science'
          },
          {
            id: 'fc3fc2a2-c981-41a3-b3af-4ac704154f4d',
            label: 'Finance',
            value: 'Finance'
          },
          {
            id: '21b01041-11d3-4295-aa1e-76cd80292a1e',
            label: 'Other',
            value: 'Other'
          }
        ],
        alphabetical_order: null,
        button_text: null,
        allow_multiple_selection: false,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: {
        _id: null,
        type: null,
        link: 'https://buildform-file-uploads-v2.s3.amazonaws.com/d3b02997ae3eb5702dc453da0fd821bd4b6513c5bba6126a99756e4e157edab3.jpg',
        properties: null,
        placement: 'left'
      },
      layout: null
    },
    {
      question_number: '8',
      id: '4d0f1399-fcfa-4864-a7b2-c075822b0f1c',
      title: 'What factors do you consider most important when choosing a career?',
      subfield_key: null,
      validations: {
        required: true
      },
      type: 'multiple_choice',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Select the factors that matter most to you when choosing a career.',
        randomize: null,
        choices: [
          {
            id: '522203b5-bb5c-470d-8043-e4c1a8da2e5c',
            label: 'Salary',
            value: 'Salary'
          },
          {
            id: 'e6ae61f8-0f49-4345-8849-2e5f1e0fc53d',
            label: 'Job Stability',
            value: 'Job Stability'
          },
          {
            id: '53dce95d-48b3-40b3-bea0-09007f3cb28f',
            label: 'Passion',
            value: 'Passion'
          },
          {
            id: '3d6d0dc7-455c-45fb-ac06-da1459c608cd',
            label: 'Work-Life Balance',
            value: 'Work-Life Balance'
          },
          {
            id: '4bc7d43a-0c5a-4960-b82c-113b1785098a',
            label: 'Career Growth',
            value: 'Career Growth'
          },
          {
            id: '0b11746c-2cbd-4e13-85a0-1f84f6e8aa10',
            label: 'Location',
            value: 'Location'
          },
          {
            id: 'd3a10492-639a-4982-98e9-a69d12ee08ac',
            label: 'Company Culture',
            value: 'Company Culture'
          }
        ],
        alphabetical_order: null,
        button_text: null,
        allow_multiple_selection: true,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '10',
      id: 'w8wfuef0b1',
      title: 'Your country?',
      subfield_key: null,
      validations: null,
      type: 'country',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Country desc',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '11',
      id: 'th6eu5n23w',
      title: 'Phone Number',
      subfield_key: null,
      validations: {
        required: true
      },
      type: 'phone_number',
      properties: {
        default_country_code: null,
        fields: null,
        description: '',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '12',
      id: 'f24398b1-5225-4af0-b048-a34976451ba4',
      title: 'Would you like to receive career counseling?',
      subfield_key: null,
      validations: {
        required: false
      },
      type: 'dropdown',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Select yes or no.',
        randomize: null,
        choices: [
          {
            id: '86092fc8-5a2b-43d9-9061-3f3219ddb9ca',
            label: 'Yes',
            value: 'Yes'
          },
          {
            id: '44e80226-3a18-43bb-b0d0-abea9ca1d901',
            label: 'No',
            value: 'No'
          }
        ],
        alphabetical_order: null,
        button_text: null,
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '13',
      id: '5xhqs98t8a',
      title: 'Contact Info',
      subfield_key: null,
      validations: null,
      type: 'contact_info',
      properties: {
        default_country_code: null,
        fields: [
          {
            question_number: null,
            id: '23def051-d517-4b78-896b-327186d6da3d',
            title: 'First Name',
            subfield_key: null,
            validations: {
              required: true
            },
            type: 'short_text',
            properties: {
              default_country_code: null,
              fields: [],
              description: '',
              randomize: null,
              choices: null,
              alphabetical_order: null,
              button_text: null,
              allow_multiple_selection: null,
              allow_other_choice: null,
              vertical_alignment: null,
              show_button: null,
              checkbox_label: null,
              allowed_file_types: null,
              rating_icon: null,
              redirection_url: null,
              labels: null,
              start_at: 1,
              end_at: 10
            },
            attachment: null,
            layout: null
          },
          {
            question_number: null,
            id: '2d5cfb9c-5c63-4b68-81de-c23cc29b2302',
            title: 'Last Name',
            subfield_key: null,
            validations: {
              required: true
            },
            type: 'short_text',
            properties: {
              default_country_code: null,
              fields: [],
              description: '',
              randomize: null,
              choices: null,
              alphabetical_order: null,
              button_text: null,
              allow_multiple_selection: null,
              allow_other_choice: null,
              vertical_alignment: null,
              show_button: null,
              checkbox_label: null,
              allowed_file_types: null,
              rating_icon: null,
              redirection_url: null,
              labels: null,
              start_at: 1,
              end_at: 10
            },
            attachment: null,
            layout: null
          }
        ],
        description: '',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: 'Next',
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    },
    {
      question_number: '14',
      id: '7c6cec5f-2340-4272-ae33-d4f4b69adac8',
      title: 'Any additional comments or questions?',
      subfield_key: null,
      validations: {
        required: false
      },
      type: 'short_text',
      properties: {
        default_country_code: null,
        fields: null,
        description: 'Please share any other thoughts about your career interests.',
        randomize: null,
        choices: null,
        alphabetical_order: null,
        button_text: null,
        allow_multiple_selection: null,
        allow_other_choice: null,
        vertical_alignment: null,
        show_button: null,
        checkbox_label: null,
        allowed_file_types: null,
        rating_icon: null,
        redirection_url: null,
        labels: null,
        start_at: 1,
        end_at: 10
      },
      attachment: null,
      layout: null
    }
  ],
  logics: [
    {
      field_id: 'd4a0123c-5a41-4347-91e6-f7e47ac1c032',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'd4a0123c-5a41-4347-91e6-f7e47ac1c032',
                  operator: 'always',
                  operand: null,
                  rule_id: '269bf1d5-99a8-4769-9acb-2c49a4eadf20'
                }
              ],
              group_name: 'Group 0',
              group_id: '324a715c-c54d-46b2-aa41-a1b06c4d2ce6'
            }
          ],
          branch_name: 'Branch 0',
          target_field_id: 'ouvtv83kx9',
          branch_id: 'f34b5537-4dac-4a9f-b85f-4a2835e363e9'
        }
      ],
      default_target_field_id: 'ouvtv83kx9'
    },
    {
      field_id: 'ouvtv83kx9',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'ouvtv83kx9',
                  operator: 'always',
                  operand: null,
                  rule_id: 'bcb12965-847b-4d57-8a4b-316436c5b1ba'
                }
              ],
              group_name: 'Group 1',
              group_id: '85ef19da-e21d-4b02-a2cd-269f42bc4db3'
            }
          ],
          branch_name: 'Branch 1',
          target_field_id: 'vjfwk29ir4',
          branch_id: '7bedc0c8-cbb7-4ffe-bcc3-d106abb06a53'
        }
      ],
      default_target_field_id: 'vjfwk29ir4'
    },
    {
      field_id: 'vjfwk29ir4',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'vjfwk29ir4',
                  operator: 'always',
                  operand: null,
                  rule_id: '31bd7c24-0fa3-4d14-972e-2fc109cd1d3f'
                }
              ],
              group_name: 'Group 2',
              group_id: '6eadf705-7956-44f6-b9d6-1af1d51892b4'
            }
          ],
          branch_name: 'Branch 2',
          target_field_id: 'tyswjp876q',
          branch_id: '2208fa91-997d-401a-a4e0-6cc011a87487'
        }
      ],
      default_target_field_id: 'tyswjp876q'
    },
    {
      field_id: 'tyswjp876q',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'tyswjp876q',
                  operator: 'always',
                  operand: null,
                  rule_id: 'f1abc60a-96df-414c-a69e-5bf1d5899174'
                }
              ],
              group_name: 'Group 3',
              group_id: 'a02833a3-40f0-43df-bba3-22ce0d148838'
            }
          ],
          branch_name: 'Branch 3',
          target_field_id: 'fj2h88d7zk',
          branch_id: '102a5e50-c423-48bb-a461-4284c3c98a5d'
        }
      ],
      default_target_field_id: 'fj2h88d7zk'
    },
    {
      field_id: 'fj2h88d7zk',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'fj2h88d7zk',
                  operator: 'always',
                  operand: null,
                  rule_id: '25afe645-e509-4336-bdae-2791dd877bcb'
                }
              ],
              group_name: 'Group 4',
              group_id: 'e9a997cc-15a1-4e0a-afc6-1e8a9c03e3dc'
            }
          ],
          branch_name: 'Branch 4',
          target_field_id: '7a6004bd-af12-434b-82a9-579ba672d197',
          branch_id: '405423e9-457f-418e-82ea-68eda43daf8a'
        }
      ],
      default_target_field_id: '7a6004bd-af12-434b-82a9-579ba672d197'
    },
    {
      field_id: '7a6004bd-af12-434b-82a9-579ba672d197',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: '7a6004bd-af12-434b-82a9-579ba672d197',
                  operator: 'always',
                  operand: null,
                  rule_id: '809e1123-c622-4066-a16b-b3643768ba4c'
                }
              ],
              group_name: 'Group 5',
              group_id: '86079d83-e7d3-4d4c-9898-d198150b8cf9'
            }
          ],
          branch_name: 'Branch 5',
          target_field_id: 'ydd5vdrzqd',
          branch_id: 'd44f2117-d6cb-4eed-9c9c-03a4a02611ab'
        }
      ],
      default_target_field_id: 'ydd5vdrzqd'
    },
    {
      field_id: 'ydd5vdrzqd',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'ydd5vdrzqd',
                  operator: 'always',
                  operand: null,
                  rule_id: 'b95a024a-7909-4758-9fc8-7db5dc02ddfd'
                }
              ],
              group_name: 'Group 6',
              group_id: '53a7424b-cf7a-4c23-9789-a846bab8c467'
            }
          ],
          branch_name: 'Branch 6',
          target_field_id: 'm99tsfx7',
          branch_id: '09dfcee5-4f5d-4683-91f1-8f05f0300ce4'
        }
      ],
      default_target_field_id: 'm99tsfx7'
    },
    {
      field_id: 'm99tsfx7',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'm99tsfx7',
                  operator: 'always',
                  operand: null,
                  rule_id: 'ee57b101-dc74-46d5-a100-3969454c7330'
                }
              ],
              group_name: 'Group 7',
              group_id: '8cdfd026-db95-49bb-bf87-8de26818434e'
            }
          ],
          branch_name: 'Branch 7',
          target_field_id: '505432ae-711e-4903-ba5d-9044fddb7a64',
          branch_id: '293a4ca0-1621-486d-a844-308193da72f9'
        }
      ],
      default_target_field_id: '505432ae-711e-4903-ba5d-9044fddb7a64'
    },
    {
      field_id: '505432ae-711e-4903-ba5d-9044fddb7a64',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: '505432ae-711e-4903-ba5d-9044fddb7a64',
                  operator: 'always',
                  operand: null,
                  rule_id: 'b3e0e763-2765-4491-9bd7-4cfdee27d735'
                }
              ],
              group_name: 'Group 8',
              group_id: '1932c640-3660-47f5-8150-9ea0124ee3cd'
            }
          ],
          branch_name: 'Branch 8',
          target_field_id: '4d0f1399-fcfa-4864-a7b2-c075822b0f1c',
          branch_id: '729fd69c-5829-47d6-b6e9-7d71d815460a'
        }
      ],
      default_target_field_id: '4d0f1399-fcfa-4864-a7b2-c075822b0f1c'
    },
    {
      field_id: '4d0f1399-fcfa-4864-a7b2-c075822b0f1c',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: '4d0f1399-fcfa-4864-a7b2-c075822b0f1c',
                  operator: 'always',
                  operand: null,
                  rule_id: '4c3ea531-0b6d-4d15-9d03-023e82eff700'
                }
              ],
              group_name: 'Group 9',
              group_id: '6923c81f-5b72-4427-8066-695b4d9f057a'
            }
          ],
          branch_name: 'Branch 9',
          target_field_id: 'w8wfuef0b1',
          branch_id: '081837cb-577b-4e72-9f4a-df3c4f097460'
        }
      ],
      default_target_field_id: 'w8wfuef0b1'
    },
    {
      field_id: 'w8wfuef0b1',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'w8wfuef0b1',
                  operator: 'always',
                  operand: null,
                  rule_id: 'c7faeb4b-8267-47fb-b065-55575d2746a8'
                }
              ],
              group_name: 'Group 10',
              group_id: 'f5400af6-cb47-45d3-b35d-19b126cd162f'
            }
          ],
          branch_name: 'Branch 10',
          target_field_id: 'th6eu5n23w',
          branch_id: '951b8ea3-951e-42b7-80d0-1fb490a0b9e4'
        }
      ],
      default_target_field_id: 'th6eu5n23w'
    },
    {
      field_id: 'th6eu5n23w',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'th6eu5n23w',
                  operator: 'always',
                  operand: null,
                  rule_id: '32dfdc63-ed93-4b36-80ad-5e3f84135511'
                }
              ],
              group_name: 'Group 11',
              group_id: '1d78a8e2-ad6b-4e87-beaf-7fb2e29c6880'
            }
          ],
          branch_name: 'Branch 11',
          target_field_id: 'f24398b1-5225-4af0-b048-a34976451ba4',
          branch_id: 'a00d3778-b418-498c-90e2-d54b6e78ca17'
        }
      ],
      default_target_field_id: 'f24398b1-5225-4af0-b048-a34976451ba4'
    },
    {
      field_id: 'f24398b1-5225-4af0-b048-a34976451ba4',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: 'f24398b1-5225-4af0-b048-a34976451ba4',
                  operator: 'always',
                  operand: null,
                  rule_id: 'b0169fd7-930f-4272-8888-158dd324d17b'
                }
              ],
              group_name: 'Group 12',
              group_id: '3e8f0c83-f0b8-4790-95a5-4e6e8a358fe2'
            }
          ],
          branch_name: 'Branch 12',
          target_field_id: '5xhqs98t8a',
          branch_id: '4ce6fdab-f7f1-4278-84d2-ac5301db1514'
        }
      ],
      default_target_field_id: '5xhqs98t8a'
    },
    {
      field_id: '5xhqs98t8a',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: '5xhqs98t8a',
                  operator: 'always',
                  operand: null,
                  rule_id: '20a94bda-b443-4d7f-b8e4-64f1b52b22df'
                }
              ],
              group_name: 'Group 13',
              group_id: '35526763-d4c8-411f-88fc-dc120a962b38'
            }
          ],
          branch_name: 'Branch 13',
          target_field_id: '7c6cec5f-2340-4272-ae33-d4f4b69adac8',
          branch_id: 'b8a93126-6121-4589-9764-6c8fb114e66f'
        }
      ],
      default_target_field_id: '7c6cec5f-2340-4272-ae33-d4f4b69adac8'
    },
    {
      field_id: '7c6cec5f-2340-4272-ae33-d4f4b69adac8',
      branches: [
        {
          logic_groups: [
            {
              rules: [
                {
                  source_field_id: '7c6cec5f-2340-4272-ae33-d4f4b69adac8',
                  operator: 'always',
                  operand: null,
                  rule_id: 'ffcfea2e-df1c-4a8c-9c56-6033c395a53e'
                }
              ],
              group_name: 'Group 14',
              group_id: 'b2dd818d-b7a0-4035-a633-c008c6d84e4d'
            }
          ],
          branch_name: 'Branch 14',
          target_field_id: 'd6765d1e-6e70-4d14-b81c-12fde62666af',
          branch_id: '2512b869-4fbe-4432-93e5-fc2fc530bd0e'
        }
      ],
      default_target_field_id: 'd6765d1e-6e70-4d14-b81c-12fde62666af'
    }
  ],
  is_ai_form: false,
  theme: {
    name: 'Default Theme',
    primary_color: 'rgb(255, 87, 51)',
    secondary_color: 'rgb(51, 255, 189)',
    background_color: 'rgb(252, 250, 255)',
    text_color: 'rgb(68, 51, 122)',
    answer_text_color: 'rgb(188,123,246)',
    font_family: {
      label: 'Inter, sans-serif',
      value: 'Inter, sans-serif',
      family: 'Inter',
      variants: [
        '100',
        '200',
        '300',
        'regular',
        '500',
        '600',
        '700',
        '800',
        '900',
        '100italic',
        '200italic',
        '300italic',
        'italic',
        '500italic',
        '600italic',
        '700italic',
        '800italic',
        '900italic'
      ],
      subsets: ['cyrillic', 'cyrillic-ext', 'greek', 'greek-ext', 'latin', 'latin-ext', 'vietnamese'],
      version: 'v18',
      last_modified: '2024-09-04',
      files: {
        '100': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyeMZhrib2Bg-4.ttf',
        '200': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuDyfMZhrib2Bg-4.ttf',
        '300': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuOKfMZhrib2Bg-4.ttf',
        '500': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuI6fMZhrib2Bg-4.ttf',
        '600': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuGKYMZhrib2Bg-4.ttf',
        '700': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuFuYMZhrib2Bg-4.ttf',
        '800': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuDyYMZhrib2Bg-4.ttf',
        '900': 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuBWYMZhrib2Bg-4.ttf',
        regular: 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfMZhrib2Bg-4.ttf',
        '100italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTc2dphjZ-Ek-7MeA.ttf',
        '200italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTcWdthjZ-Ek-7MeA.ttf',
        '300italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTch9thjZ-Ek-7MeA.ttf',
        italic: 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTc2dthjZ-Ek-7MeA.ttf',
        '500italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTc69thjZ-Ek-7MeA.ttf',
        '600italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTcB9xhjZ-Ek-7MeA.ttf',
        '700italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTcPtxhjZ-Ek-7MeA.ttf',
        '800italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTcWdxhjZ-Ek-7MeA.ttf',
        '900italic': 'https://fonts.gstatic.com/s/inter/v18/UcCM3FwrK3iLTcvneQg7Ca725JhhKnNqk4j1ebLhAm8SrXTccNxhjZ-Ek-7MeA.ttf'
      },
      category: 'sans-serif',
      kind: 'webfonts#webfont',
      menu: 'https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfAZlhjQ.ttf'
    },
    visibility: 'private',
    logo: {
      _id: null,
      type: 'image',
      link: '',
      properties: {
        description: '',
        focal_point: {
          x: 0.5,
          y: 0.5
        }
      },
      placement: 'top'
    },
    button_color: 'rgb(128, 90, 213)',
    button_text_color: 'rgb(255, 255, 255)',
    button_size: 'large',
    button: {
      color: 'rgb(128, 90, 213)',
      size: 'large',
      text_color: 'rgb(255, 255, 255)',
      border_radius: 4,
      is_bold: true
    },
    text_size: 'medium',
    rounded_corners: 4,
    show_buildform_branding: true,
    branding_logo_link: null,
    _id: '67ea3a3ae3e47d18899cde23'
  }
};
